module.exports = __webpack_public_path__ + "static/media/notification-active.4e331b43.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/notification-active.svg
 ** module id = 319
 ** module chunks = 0
 **/